import { render } from "./OnboardingIndex.vue?vue&type=template&id=558e3c45"
import script from "./OnboardingIndex.vue?vue&type=script&lang=js"
export * from "./OnboardingIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__